import post, { API } from '../../net/http';

export default {
  namespaced: true,
  actions: {
    login({ commit }, { api, body }) {
      return post(api, body).then(res => {
        if (res.success && res.message !== 'needs bound existing account') {
          const data = res.data;
          commit('app/login', { ...data }, { root: true });
        }
        return res;
      });
    },
    logout({ commit }) {
      return post(API.logout).then(res => {
        commit('app/logout', null, { root: true });
        return res;
      });
    },
  },
};
